import type { Language } from 'core/service/user-language/user-language.api';
import { DEFAULT_LANGUAGE } from 'core/constants/constants';

export const resolveSupportedLanguage = (language: string, supportedLanguages: Language[]): string =>
    supportedLanguages.some((supported) => supported.value === language) ? language : DEFAULT_LANGUAGE;
